module.exports = __webpack_public_path__ + "img/rating-video-play-button.e31b89f4.svg";